module.exports = __webpack_public_path__ + "static/media/test.94ee9578.svg";